import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.reviewops.peer.comparison');
import { Input } from '@angular/core';

interface PeerMetric {
    label: string;
    unit: string;
    comparison: {
        status: string;
        direction: string;
        company_value: number | null;
        industry_median: number | null;
    };
}

interface PeerAnalysisData {
    peer_count?: number;
    sample_size?: number;
    source_type?: string;
    reliability?: string;
    benchmark_label?: string;
    dataset_notice?: string;
}

@Component({
    selector: 'wiz-component-reviewops-peer-comparison',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.reviewops.peer.comparison/view.scss */
/* src/app/component.reviewops.peer.comparison/view.scss: no such file or directory */`],
})
export class ComponentReviewopsPeerComparisonComponent {
    @Input() metrics: PeerMetric[] = [];
    @Input() peerAnalysis: PeerAnalysisData = {};

    public display(value: number | null | undefined, unit: string = ''): string {
        if (value === null || value === undefined) return '데이터 부족';
        return Number(value).toLocaleString('ko-KR', { maximumFractionDigits: 1 }) + unit;
    }

    public relativeBar(value: number | null, metric: PeerMetric): number {
        if (value === null || value === undefined) return 0;
        const company = Math.abs(Number(metric.comparison.company_value || 0));
        const median = Math.abs(Number(metric.comparison.industry_median || 0));
        return Math.max(6, Math.round(Math.abs(value) / Math.max(company, median, 1) * 100));
    }
}

export default ComponentReviewopsPeerComparisonComponent;